import { render, staticRenderFns } from "./JobInfoCard.vue?vue&type=template&id=71e63933&scoped=true"
import script from "./JobInfoCard.vue?vue&type=script&lang=js"
export * from "./JobInfoCard.vue?vue&type=script&lang=js"
import style0 from "./JobInfoCard.vue?vue&type=style&index=0&id=71e63933&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e63933",
  null
  
)

export default component.exports